import React from 'react';
import { generatePath, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import ConfirmationDialog from './ConfirmationDialog';
import routes from '../routes';
import useHasActiveFeatureFlag from '../hooks/useFeatureFlags';
import { FF_REQUIRE_FOOD_SAFETY_COURSE_COMPLETION } from './FeatureFlagWrapper';
import * as uiPersistedActions from '../actions/uiPersisted';

const FoodSafetyCourseConfirmationDialog = ({ isMobile = false }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const hasActiveRequireFoodSafetyFF = useHasActiveFeatureFlag(FF_REQUIRE_FOOD_SAFETY_COURSE_COMPLETION);
  const onRescueSafetyDialogClose = () => dispatch(uiPersistedActions.hideFoodSafetyDialog());

  const onRescueSafetyDialogCancel = () => {
    if (hasActiveRequireFoodSafetyFF) {
      return isMobile
        ? history.push(generatePath(routes.mobileDashboard))
        : history.push(generatePath(routes.dashboardRescuer));
    }

    return onRescueSafetyDialogClose();
  };

  const onLearnClick = () => {
    if (isMobile) {
      return history.push(generatePath(routes.mobileDashboardLearn));
    }

    return history.push(generatePath(routes.learn));
  };

  return (
    <ConfirmationDialog
      isMobile={isMobile}
      buttons={[
        {
          variant: 'outlined',
          label: hasActiveRequireFoodSafetyFF ? 'Go Back' : 'Maybe Later',
          color: 'primary',
          onClick: onRescueSafetyDialogCancel,
        },
        {
          variant: 'contained',
          label: 'Learn',
          color: 'primary',
          onClick: onLearnClick,
        },
      ]}
      closeDialog={onRescueSafetyDialogClose}
      title="Food Safety is serious!"
      message={
        hasActiveRequireFoodSafetyFF
          ? `Completing the food safety course is required before accessing this page. 
          Please take a minute to complete the course to ensure the food you work so hard 
          to recover is safe and ready for the people who need it most.`
          : `Please take a minute to complete our food safety course to ensure the food 
        you work so hard to recover is safe and ready for the people who need it most.`
      }
    />
  );
};

export default FoodSafetyCourseConfirmationDialog;
